export const SAVE_DELIVERY_ORDER = '/delivery_order/orders/save/:id/';

export const SEARCH_DELIVERY_METHOD = '/delivery_services/delivery_method/search/';



// WEBPACK FOOTER //
// ./src/store/api-points.js